import { Link, Outlet, useLocation } from 'react-router-dom';

const LABELS = {
	client: 'Client',
	secure: 'Secure Account',
	search: 'Search for Services',
	organizations: 'Organizations',
	confirm: 'Confirm and Submit',
};

const NewApplication = () => {
	const location = useLocation();
	let label = LABELS.search;
	const currentStep = location.pathname.split('/').slice(-1)[0];
	if (LABELS[currentStep]) {
		label = LABELS[currentStep];
	} else if (location.pathname.includes('profile')) {
		label = LABELS.client;
	}
	return (
		<div className="new-application">
			<div className="breadcrumbs">
				<ul>
					<li>
						<Link to="/">Home</Link>
					</li>
					<li>
						<Link to="/newApplication">New Application</Link>
					</li>
					<li>{label}</li>
				</ul>
			</div>
			<Outlet />
		</div>
	);
};

export default NewApplication;
